// extracted by mini-css-extract-plugin
module.exports = {"tableUserCount":"styles__tableUserCount___dWlqz","resultCount":"styles__resultCount___NinPH","userTable":"styles__userTable___GQgb8"};